// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Table_mainWrapper__Rqhos","header":"Table_header__Bzw6l","downloadButton":"Table_downloadButton__Tj6L8"};